import { render, staticRenderFns } from "./FormTable.vue?vue&type=template&id=b0d4de04&scoped=true"
import script from "./FormTable.vue?vue&type=script&lang=js"
export * from "./FormTable.vue?vue&type=script&lang=js"
import style0 from "./FormTable.vue?vue&type=style&index=0&id=b0d4de04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d4de04",
  null
  
)

export default component.exports